module.exports = __webpack_public_path__ + "static/media/snack.9204bdf6.jpg";